"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = void 0;
var isDefined = function (value) {
    return value !== null && value !== undefined;
};
exports.isDefined = isDefined;
